const ADT = {
  length: 8.7,
  bodyWidth: 2.72,
  wheelRadius: 0.76,
  tyreWidth: 0.42,
  axles: [
    { fitment: 'single', x: 2.65, halfTrack: 1.08 },
    { fitment: 'single', x: -0.45, halfTrack: 1.04 },
    { fitment: 'single', x: -2.75, halfTrack: 1.04 },
  ],
  chassisY: 1.28,
};

export { ADT };
